<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="pv"></a><a href="#/Contents.htm#ch0a">To Donald Webster Gillies<br/>POW, husband, father, grandfather.</a><a id="pvi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?3c93a69f